import { createSvgIcon } from '@mui/material';
import React from 'react';

export const Deals = createSvgIcon(
    <>
        <path
            d="M19.3037 13.7727L20.9785 14.1526L20.8242 15.8635L21.9648 17.1467L20.8242 18.4299L20.9785 20.1399L19.3037 20.5208L18.4131 21.9934L16.833 21.3167L15.2529 21.9934L14.3613 20.5208L12.6865 20.1399L12.8408 18.4299L11.7002 17.1467L12.8408 15.8635L12.6865 14.1526L14.3613 13.7727L15.2529 12.3L16.833 12.9768L18.4131 12.3L19.3037 13.7727ZM16.1328 17.7229L14.9668 16.5706L14.2666 17.2698L16.1328 19.1223L19.3994 15.8704L18.6992 15.1702L16.1328 17.7229Z"
            fill="currentColor"
        />
        <path
            d="M14.2041 2.01074C15.1134 2.10293 15.8407 2.80422 15.9756 3.7002H18C19.1046 3.7002 20 4.59563 20 5.7002V10.2559H18V5.7002H16V7H8V5.7002H6V19.7002H10.1377V21.7002H6C4.89553 21.7002 4.00013 20.8046 4 19.7002V5.7002C4 4.59564 4.89545 3.70022 6 3.7002H8.02539C8.17024 2.73807 8.99748 2 10 2H14L14.2041 2.01074ZM10 5H14V4H10V5Z"
            fill="currentColor"
        />
    </>,
    'Deals'
);
